import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import styles from "./perspective-trigger.module.css"

@tagName("")
export default class PerspectiveTrigger extends Component {
  readonly styles = styles
}
